import { ADD_GLOBAL_MAP, REMOVE_GLOBAL_MAP } from '../actions/actionTypes';

const initialState = [];

const globalMapsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_GLOBAL_MAP:
      return [...state, { map: payload, id: payload.values_.target }];
    case REMOVE_GLOBAL_MAP:
      return state.filter((map) => map.map.values_.target !== payload.id);
    default:
      return state;
  }
};

export default globalMapsReducer;
